/**
 * @fileoverview Utility functions for app layout drawer transitions.
 */

import type { Theme } from '@mui/material';

/**
 * Return type for drawer transition sx mixin.
 */
interface DrawerTransitionSxMixin {
  transition: (theme: Theme) => string;
}

/**
 * Return type for drawer width transition sx mixin.
 */
interface DrawerWidthTransitionSxMixin extends DrawerTransitionSxMixin {
  overflowX: 'hidden';
}

/**
 * Creates an sx mixin for drawer property transitions.
 */
export function getDrawerSxTransitionMixin(isExpanded: boolean, property: string): DrawerTransitionSxMixin {
  return {
    transition: (theme: Theme) =>
      theme.transitions.create(property, {
        easing: theme.transitions.easing.sharp,
        duration: isExpanded
          ? theme.transitions.duration.enteringScreen
          : theme.transitions.duration.leavingScreen,
      }),
  };
}

/**
 * Creates an sx mixin for drawer width transitions.
 */
export function getDrawerWidthTransitionMixin(isExpanded: boolean): DrawerWidthTransitionSxMixin {
  return {
    ...getDrawerSxTransitionMixin(isExpanded, 'width'),
    overflowX: 'hidden',
  };
}

